import React, { useEffect } from 'react';
import { Popover } from '@mantine/core';
import { useBoolean } from 'ahooks';

import { PickerPanel } from './panel';

export const ColorPicker = ({ value = '#000000', closeOnBlur, name, onChange }) => {
  const [opened, actions] = useBoolean(false);

  // 自定义popover样式
  const popoverStyle = () => {
    return {
      dropdown: {
        padding: 0,
        border: 0,
      },
    };
  };

  useEffect(() => {
    if (!closeOnBlur) return;

    const outsideClickHandler = (event) => {
      if (!event.target.closest('.color-picker-panel') && !event.target.closest('.color-picker-entry')) {
        actions.setFalse();
      }
    };

    document.addEventListener('click', outsideClickHandler);

    return () => {
      document.removeEventListener('click', outsideClickHandler);
    };
  }, [closeOnBlur]);

  return (
    <Popover width={300} position="bottom" shadow="md" styles={popoverStyle} opened={opened}>
      <Popover.Target>
        <div className="color-picker-entry p-[4px] rounded-[4px] bg-[#F4F6F8] cursor-pointer" onClick={actions.toggle}>
          <div className="w-[16px] h-[16px] rounded-[4px]" style={{ backgroundColor: value }}></div>
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <PickerPanel color={value} onChange={(value) => onChange(value, name)} onClose={actions.setFalse} />
      </Popover.Dropdown>
    </Popover>
  );
};
